module.exports = __webpack_public_path__ + "static/media/score.7b3a5fec.png";